export default "__VITE_ASSET__Bl0vlB7K__"